<template>
<admin-template subtitle="Applicants">
  <list-nav
    :active.sync="activeItem"
    :tabItems="['active', 'closed']"
    :keyword.sync="searchKeyword"
    :selectedItem.sync="filterBy"
    :selectItems = "[]"
    :showSearch="false"
    type="application"
  />
  <div class="applications p-t-8" v-if="filteredApplications.length > 0">
    <div class="applications-header">
      <heading class="">
        <label v-if="false">Active jobs</label>
      </heading>
      <div class="stat-headers is-hidden-touch">
        <heading class="small">Applied</heading>
        <heading class="small">Interview</heading>
        <heading class="small">Hired</heading>
      </div>
    </div>
    <div class="applications-body">
        <application-job-card v-for="application in filteredApplications"
          @click="showApplication(application.id)" :key="application.id"
          :application="application" />
    </div>
  </div>
  <empty-state v-else title="'No Applicants'" icon="empty-state-eyes" >
    <template slot="content">
      No applicants to see here, yet. Tip: Share your job and encourage people to apply or refer somebody to earn a HVT Reward and Donation.
    </template>
  </empty-state>
</admin-template>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AdminTemplate from './admin-sub'
import ListNav from '../../components/general/list-nav.vue'
import UserCard from '@/components/general/user-row-card'
import RowCard from '@/components/general/row-card'
import ApplicationJobCard from '@/components/applications/application-job-row-card'
import JobCard from '@/components/jobs/job-row-card'
import Heading from '@/components/general/heading'
import EmptyState from '@/components/general/empty-state'

export default {
  components: {
    AdminTemplate,
    ApplicationJobCard,
    ListNav,
    RowCard,
    UserCard,
    Heading,
    JobCard,
    EmptyState
  },
  computed: {
    ...mapState('adminApplications', [
      'applications', 'searchApplication'
    ]),
    filteredApplications () {
      switch (this.activeItem) {
        case 'active':
          if (this.searchApplication) {
            return this.applications.filter(job => {
              return job.status === 'published' && this.searchApplication && ((job.companyName && job.companyName.toLowerCase().includes(this.searchApplication.toLowerCase())) || (job.title && job.title.toLowerCase().includes(this.searchApplication.toLowerCase())))
            })
          } else {
            return this.applications.filter(job => {
              return job.status === 'published'
            })
          }
        default:
          if (this.searchApplication) {
            return this.applications.filter(job => {
              return job.status !== 'published' && this.searchApplication && ((job.companyName && job.companyName.toLowerCase().includes(this.searchApplication.toLowerCase())) || (job.title && job.title.toLowerCase().includes(this.searchApplication.toLowerCase())))
            })
          } else {
            return this.applications.filter(job => {
              return job.status !== 'published'
            })
          }
      }
    }
  },
  methods: {
    ...mapActions('adminApplications', {
      getAllApplications: 'getAll'
    }),
    showApplication (applicationId) {
      this.$router.push(`/admin/applications/${applicationId}`)
    }
  },
  mounted () {
    this.getAllApplications()
  },
  data () {
    return {
      activeItem: 'active',
      searchKeyword: '',
      filterBy: 'Company'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.application:not(:first-child) {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.application:not(:last-child) {
  border-bottom: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.columns.application:hover {
  .column .card {
    cursor: pointer;
    background-color: $hover-background;
  }
}
.columns {
  margin-bottom: 0rem;
}
.column.left {
  margin-right: 0px;
  padding-right: 0px;

  .card {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.column.right {
  margin-left: 0px;
  padding-left: 0px;
  .card {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: 0;
  }
}

.applications-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-bottom;
  margin-bottom: 0.5rem;
}
.stat-headers {
  margin-bottom: -0.5rem;
  display: flex;
  width: 300px;
  justify-content: space-between;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/applications.vue